export function safeFilePart(value: string | undefined, fallback: string) {
  const safe = (value || '').replace(/[^A-Za-z0-9._-]/g, '-');
  return safe || fallback;
}
